var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointexpiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "calendar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.093,
    x2: 17.917,
    y1: 7.404,
    y2: 7.404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.442,
    x2: 13.451,
    y1: 11.31,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.005,
    x2: 9.014,
    y1: 11.31,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.558,
    x2: 4.567,
    y1: 11.31,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.442,
    x2: 13.451,
    y1: 15.196,
    y2: 15.196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.005,
    x2: 9.014,
    y1: 15.196,
    y2: 15.196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.558,
    x2: 4.567,
    y1: 15.196,
    y2: 15.196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.044,
    x2: 13.044,
    y2: 3.291
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.966,
    x2: 4.966,
    y2: 3.291
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2382655,1.57919622 L4.77096342,1.57919622 C1.83427331,1.57919622 0,3.21513002 0,6.22222222 L0,15.2718676 C0,18.3262411 1.83427331,20 4.77096342,20 L13.2290015,20 C16.1749556,20 18,18.3546099 18,15.3475177 L18,6.22222222 C18.0092289,3.21513002 16.1842196,1.57919622 13.2382655,1.57919622 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointexpiry);
export default __webpack_public_path__ + "static/media/Pointexpiry.d5acbddb9044bccf3c94ea2c254b4068.svg";
export { ForwardRef as ReactComponent };